import nftImage from "../assets/images/jpg/digital-art-icon-nft-related-vector-41202274.jpg";

const Jpg = {
  nftImage,
};
export default Jpg;
